import CaisseJourneysPage from "../pages/admin/CaissesJourney";
import CommercielManagementPage from "../pages/admin/UsersManagement";
import PagedashboardAdmin from "../pages/admin/dashbordAdmin ";
import PageGestionMagasin from "../pages/admin/GestionMagasin";
import PageBookingList from "../pages/users/BookingList";
import PageTransaction from "../pages/users/TransactionPage";
import TransactionParCaissePage from "../pages/admin/TransactionParCaisse";
import CheckManagementPage from "../pages/admin/CheckManagment";
import PagedashboardUser from "../pages/users/DasboardUser";
import PageUserStatistique from "../pages/admin/UserStatistique";
import DetaillTransactionPage from "../pages/all/DetaillTransaction";
import VirementManagementPage from "../pages/admin/virementsManagement";
import CartManagementPage from "../pages/admin/CartManagement";
import DetaillBookingPage from "../pages/all/DetaillBooking";

const PriviteRoute = [
  {
    path: "/",
    element: <PagedashboardAdmin />,
    role: "admin",
  },
  {
    path: "/dashboard",
    element: <PagedashboardAdmin />,
    role: "admin",
  },
  {
    path: "/magasin",
    element: <PageGestionMagasin />,
    role: "admin",
  },
  {
    path: "/users",
    element: <CommercielManagementPage />,
    role: "admin",
  },
  {
    path: "/CaisseJourney/:idCaisse",
    element: <CaisseJourneysPage />,
    role: "admin",
  },
  {
    path: "/TransactionParCaisse/:id",
    element: <TransactionParCaissePage />,
    role: "admin",
  },
  {
    path: "/check",
    element: <CheckManagementPage />,
    role: "admin",
  },
  {
    path: "/virements",
    element: <VirementManagementPage />,
    role: "admin",
  },
  {
    path: "/Cart",
    element: <CartManagementPage />,
    role: "admin",
  },
  {
    path: "/userStatistique/:id",
    element: <PageUserStatistique />,
    role: "admin",
  },

  //////////

  {
    path: "/bookings",
    element: <PageBookingList />,
    role: ["commercial", "captain"],
  },
  {
    path: "/transactions",
    element: <PageTransaction />,
    role: ["commercial", "captain"],
  },
  {
    path: "/dashboard-user",
    element: <PagedashboardUser />,
    role: ["commercial", "captain"],
  },

  // all

  {
    path: "DetaillTransaction/:id",
    element: <DetaillTransactionPage />,
    role: ["commercial", "admin"],
  },
/*  {
    path: "DetaillBooking/:id",
    element: <DetaillBookingPage />,
    role: ["commercial", "admin"],
  }*/,
];

export default PriviteRoute;
